<!DOCTYPE html>
@if (gameData) {
  <div>
    <div mat-dialog-actions align="end">
      <button mat-button class="cross-btn" (click)="closeDialog()"><img src="assets/images/cross-img.png" /></button>
    </div>
    <ion-card>
      <span class="rapid-fire" >
        @if (gameData?.gameData?.category == 'Rapid Fire') {
          <ion-row class="pr ion-no-padding" >
            <ion-col size="7" class="leftside-promotional ion-no-padding">
              <img src="assets/icon/rapid-fire-icon.svg" alt="fire-point-icon" />
              <span class="pop-corner-text">{{('game_preview_popup.rapid_fire_title' | translate) ? ('game_preview_popup.rapid_fire_title' | translate) : 'RAPID FIRE'}}</span>
            </ion-col>
            <ion-col size="5" class="leftside-promotional ion-no-padding">
              <div class="carousel-timer-wrapper">
                <h1 class="carousel-clock-image-ellipse">
                  <img src="../../../assets/icon/timer-light.svg" class="clock-ic-one" />
                </h1>
                <app-count-down-timer
                  class="remaining-time"
                  end="{{ rapidFireDetails?.draw_date?.seconds }}"
                  type="seconds"
                  >
                </app-count-down-timer>
              </div>
            </ion-col>
          </ion-row>
        }
      </span>
      <img class="game-preview-image" alt="Silhouette of mountains" [src]="gameData?.gameData?.ref?.game_popup_image_url" />
      <!-- <img
      class="refresh-icon"
          [src]="
          gameData?.gameData?.game_type_id == 13
              ? 'assets/icon/refresh-3x.png'
              : gameData?.gameData?.game_type_id == 14
              ? 'assets/icon/users.svg'
              : ''
          "
      /> -->
      @if (gameData?.gameData?.game_type_id == 13 || gameData?.gameData?.game_type_id == 14) {
        <div class="r-append-img background-refresh">
          <img
            class="refresh-icon"
            alt="refresh"
            [src]="
            gameData?.gameData?.game_type_id == 13
                ? 'assets/icon/refreshIcon.png'
                : gameData?.gameData?.game_type_id == 14
                ? 'assets/icon/users.svg'
                : ''
            "
            [ngClass]="{
              'refresh-top-margin-popup': gameData?.gameData?.game_type_id == 13,
              'users-top-margin-popup': gameData?.gameData?.game_type_id == 14
            }"
            />
          </div>
        }
        @if ((gameData?.gameData?.game_type_id != 13) && (gameData?.gameData?.game_type_id != 14)) {
          <div class="background-refresh background-refresh-non"></div>
        }
        <!-- <img src="assets/icon/refresh-3x.png" alt="refresh"  class="refresh-icon"> -->
        <ion-card-header class="ion-no-padding">
          <div class="prize-tag-cover" >
            <span class="preview-price-tag bg-{{ gameData.gameData?.tier }}">
              {{ gameData.gameData.ref.top_prize}}
            </span>
            <!-- <span class="preview-price-tag bg-{{ gameData?.gameData?.tier}}">{{gameData.gameData.ref.top_prize}}</span> -->
          </div>
          <ion-card-title class="card-title"> {{'homePage.Top Prize' | translate}}</ion-card-title>
          @if (gameData?.gameData?.game_type_id == 13) {
            <p class="sub-desc"  >{{ gameData?.gameData.ref['game_short_title'] }}</p>
          }
          <ion-card-subtitle class="sub-card-title">{{gameData.gameData.ref['int_game_short_title']}}
            <b> {{ gameData.gameData.ref?.must_win_prize ? gameData.gameData.ref?.must_win_prize : "" }} </b>
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-button expand="block" color="secondary" class="game-preview-btn" type="submit" (click)="playGame(gameData.gameData.ref)">
            {{'homePage.Play now' | translate}}
            <!-- <img class="point-coin" src="assets/images/pointIcon.png" alt="pointcoin" /> -20 -->
            <img class="point-coin" src="assets/images/pointIcon.png" alt="pointcoin" /> - <span
          class="pop-price-span">{{gameData?.gameData?.ref?.game_price }}</span>
        </ion-button>
        <!--Derick decided not to show Learn more page from Gaming  sub-tab.  -->
        <!-- <div class="preview-learn-more" (click)="goToGameDetails(gameData.gameData.ref?.adventure_id,gameData.gameData.ref?.game_type_id, gameData.gameData.ref?.game_id, gameData.gameData.ref?.category)">{{'homePage.Learn' | translate}}</div> -->
      </ion-card-content>
    </ion-card>
  </div>
} @else {
  <mat-spinner></mat-spinner>
}

